import React from 'react';
import { Link } from '@reach/router';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import classes from './chat.module.scss';
import { formatDate } from '../../utils/dateUtils';

const MessageList = props => {
  return (
    <>
      {props.chat.map((message: any, index: number) => {
        const me = message.author.id === props.me;
        const displayDate = formatDate(message.createdAt);

        return (
          <div
            key={index}
            className={`${classes.messageContainer} ${
              me ? classes.right : classes.left
            }`}
          >
            <Link to={`/baker/${message.author.id}`}>
              <Avatar
                alt={message.author.firstName}
                src={message.author.image}
              />
            </Link>
            <div className={classes.message}>
              <Typography component="p" className={classes.messageHeader}>
                {message.author.firstName}, {displayDate}
              </Typography>
              <Paper elevation={1} className={classes.text}>
                <Typography component="p">{message.text}</Typography>
              </Paper>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default MessageList;
